import Model, { attr } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import { belongsTo, hasMany } from '@warp-drive/legacy/model';
import type CompanyModel from './company.ts';
import type PslfFormModel from './pslf-form';
import type PslfProfileModel from './pslf-profile.ts';

export default class PslfGroupModel extends Model {
  @attr declare approverEmail: string;
  @attr declare approverName: string;
  @attr declare approverPhoneNumber: string;
  @attr declare approverTitle: string;
  @attr declare approverVerifyWithEmail: boolean;
  @attr declare createdBy: Record<string, unknown>;
  @attr declare createdOn: string;
  @attr declare deletedAt: string;
  @attr declare employerAddressLine1: string;
  @attr declare employerAddressLine2: string;
  @attr declare employerCity: string;
  @attr declare employerCommonName: string;
  @attr declare employerFein: string;
  @attr declare employerIsGovernment: boolean;
  @attr declare employerIsNotForProfit: boolean;
  @attr declare employerIsPolitical: boolean;
  @attr declare employerIsTaxExempt: boolean;
  @attr declare employerLegalName: string;
  @attr declare employerPostalCode: string;
  @attr declare employerServices: string[];
  @attr declare employerState: string;
  @attr declare employerWebsite: string;
  @attr declare updatedBy: Record<string, unknown>;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;
  @attr declare legacyId: string;
  @attr declare autoSign: boolean;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @hasMany('pslf-form', { async: false, inverse: 'pslfGroup' })
  declare pslfForms: PslfFormModel[];
  @belongsTo('pslf-profile', { async: false, inverse: null })
  declare autoApproverProfile: PslfProfileModel;

  [Type] = 'pslf-group' as const;
}
